import {
  INIT_REGION_LIST_REQUEST,
  SET_REGION_LIST,
  ERROR_REGION_LIST,
  ADD_REGION,
  SET_REGION,
  UPDATE_REGION,
  ERROR_REGION,
  DELETE_REGION
} from './action';

const initialState = {
  data: {
    data: [],
    pagination: {
      totalItems: 0,
      resultlength: 0,
      totalPages: 1,
      currentPage: 1
    }
  },
  error: null,
  isLoading: false,
  selectedRegion: null,
};

const regionListReducer = (state = initialState, action) => {
  switch (action.type) {
    case INIT_REGION_LIST_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };

    case SET_REGION_LIST:
      return {
        ...state,
        data: action.payload,
        isLoading: false,
        error: null,
      };

    case ERROR_REGION_LIST:
      return {
        ...state,
        data: {
          data: [],
          pagination: { totalItems: 0, resultlength: 0, totalPages: 1, currentPage: 1 }
        },
        isLoading: false,
        error: action.payload,
      };

    case ERROR_REGION:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };

    case ADD_REGION:
      return {
        ...state,
        isLoading: false,
        error: null,
      };

    case UPDATE_REGION:
      return {
        ...state,
        isLoading: false,
        error: null,
      };

    case SET_REGION:
      return {
        ...state,
        isLoading: false,
        selectedRegion: action.payload,
        error: null,
      };

    case DELETE_REGION:
      return {
        ...state,
        isLoading: false,
        error: null,
      };

    default:
      return state;
  }
};

export default regionListReducer;
